import { LocalizedLandingPage } from '@/pages/LocalizedLandingPage';
import { DE_CONTENT } from '@/pages/landingContent';

export function DeLandingPage() {
    return <LocalizedLandingPage route="/de" content={DE_CONTENT} />;
}
